import { render } from "./richheight.vue?vue&type=template&id=28d6f993"
import script from "./richheight.vue?vue&type=script&setup=true&lang=js"
export * from "./richheight.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/richheight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28d6f993"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28d6f993', __exports__)) {
    api.reload('28d6f993', __exports__)
  }
  
  module.hot.accept("./richheight.vue?vue&type=template&id=28d6f993", () => {
    api.rerender('28d6f993', render)
  })

}


export default __exports__